import { jobFileAttachment, type JobFileEntry } from '@jobos/shared';

import { useJobFolders } from '@/hooks/useJobFolders';
import { ATTACHMENT_BADGES } from './jobFileDisplay';

// Pending / Unattached, derived rather than stored. One component so the grid
// and the list can't drift into labelling the same file differently — and so
// the truth table lives in exactly one place (see `jobFileAttachment`).

export function JobFileAttachmentBadge({ jobId, file }: { jobId: string; file: JobFileEntry }) {
  const { data: folders } = useJobFolders(jobId);
  const expensesFolderId = folders?.find((folder) => folder.slug === 'expenses')?.id ?? null;

  const state = jobFileAttachment(file, expensesFolderId);
  const badge = state ? ATTACHMENT_BADGES[state] : null;
  if (!badge) return null;

  return (
    <span
      className={`inline-block rounded px-1.5 py-0.5 text-[10px] font-medium ${badge.className}`}
    >
      {badge.label}
    </span>
  );
}
